import 'reflect-metadata';
import FeaturedListingsPreview from 'src/components/common/featured-listings-preview/featured-listings-preview';
import Advantages from 'src/components/pages/sign-up/advantages/advantages';
import CreateAccount from 'src/components/pages/sign-up/create-account/create-account';
import { useEffect } from 'react';
import styles from './sign-up.module.scss';
import { GetStaticProps, GetStaticPropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { SignUpPageActions } from 'src/store/pages/sign-up/actions';
import { i18n } from 'next-i18next.config';
import { useDispatch } from 'react-redux';
import { wrapper } from 'src/store/store';
import { LayoutType } from '../../components/layout/layout';
import { Store } from 'redux';
import { AppState } from 'src/store/state';
import Head from 'next/head';
import { FeaturedListingsActions, loadFeaturedListingsTask } from 'src/store/featured-listings';
import { configuration } from '../../configurations/configuration';

const SignUpPage = (): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(
    () => () => {
      dispatch(SignUpPageActions.resetState());
    },
    []
  );

  return (
    <>
      <Head>
        <title>Buy Mineral Rights - Browse Listing at US Mineral Exchange</title>
        <meta
          name='description'
          content='If you want to buy mineral rights, browse available listing at US Mineral Exchange. We provide quality leads by working directly with the seller.'
        />
        <meta
          name='keywords'
          content='' />
        <link
          rel='canonical'
          href={`${process.env.NEXT_PUBLIC_URL}/sign-up`} />
      </Head>
      <div className={styles.signup}>
        <Advantages className={styles.signup_advantages} />
        <CreateAccount className={styles.signup_createaccount} />
        <FeaturedListingsPreview className={styles.signup_listings} />
      </div>
    </>
  );
};

SignUpPage.layout = LayoutType.HOME;

export default SignUpPage;

export const getStaticProps: GetStaticProps = wrapper.getStaticProps(
  (store: Store<AppState>) => async ({ locale, preview }: GetStaticPropsContext) => {
    if (preview) {
      return {
        redirect: {
          permanent: false,
          destination: configuration.redirectPaths.checkPreview
        }
      };
    }

    store.dispatch(FeaturedListingsActions.loadFeaturedListingsForServer());

    await loadFeaturedListingsTask?.toPromise();

    return {
      props: {
        ...(await serverSideTranslations(locale ?? i18n.defaultLocale, [
          'common',
          'components:layout',
          'components:common:featured-listing-preview',
          'components:pages:sign-up:advantages',
          'components:pages:sign-up:create-account'
        ]))
      },
      revalidate: configuration.revalidation.timeSec
    };
  }
);
